import { USER_CONSTANTS } from "@/modules/User/constants/UserConstants";
import { NAME_FIELD } from "@/modules/UserTemplate/constants/UserTemplateConstants";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { STRING_TYPE } from "@/shared/constants/GeneralConstants";
import {
  DYNAMIC_SELECT_EVENTS,
  DYNAMIC_SELECT_REF,
  DYNAMIC_SELECT_TEXT,
  SELECT_EVENTS
} from "@/shared/constants/SelectConstants";
import {
  SNACKBAR_STYLE,
  STYLE_CLASSES
} from "@/shared/constants/StyleConstants";
import { Utils } from "@/shared/utils/utils";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { DynamicSelectConfig } from "./model/DynamicSelectConfig";
import { DynamicSelectData } from "./model/DynamicSelectData";

@Component({
  name: "DynamicSelect"
})
export default class DynamicSelect extends Vue {
  @Prop() dynamicSelectConfig!: DynamicSelectConfig;
  @Prop() dynamicSelectList!: DynamicSelectData[];
  @Prop({ default: "DynamicSelect" }) id!: string;
  @Prop() addItemMessage!: string;
  @Prop({ default: false }) disabled!: boolean;
  @Prop({ default: false }) outsideEnabled!: boolean;

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  textNotFound = DYNAMIC_SELECT_TEXT.NOT_FOUND;
  requiredField = [
    this.dynamicSelectConfig.required
      ? FORM_VALIDATORS.REQUIRED_LIST
      : FORM_VALIDATORS.NO_REQUIRED_LIST
  ];
  WARNING_COLOR = SNACKBAR_STYLE.WARNING.COLOR;
  NOT_FOUND_DATA = USER_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND_DATA;
  noData = false;
  keyWord = "";
  loading = false;
  cont: any = 0;
  menuOpen = false;
  contentClass = `dynsel-menu-${Math.random()
    .toString(36)
    .slice(2)}`;
  private menuCloseTimer: number | null = null;

  get attachLocal(): string | boolean {
    return this.dynamicSelectConfig.attach == undefined
      ? true
      : typeof this.dynamicSelectConfig.attach == STRING_TYPE &&
        this.dynamicSelectConfig.attach
      ? "#" + this.dynamicSelectConfig.attach
      : !!this.dynamicSelectConfig.attach;
  }

  mounted() {
    if (this.dynamicSelectConfig.listAll.length == 0) {
      this.$emit(SELECT_EVENTS.EMITTERS.FETCH_DATA);
    }
    if (this.dynamicSelectConfig.textNotFound) {
      this.textNotFound = this.dynamicSelectConfig.textNotFound;
    }
  }

  get backgroundColor(): string {
    return this.WARNING_COLOR;
  }

  get dynamicSelectListLocal(): DynamicSelectData[] | DynamicSelectData {
    if (this.dynamicSelectConfig.multiple) {
      return [...(this.dynamicSelectList || [])];
    }
    return this.dynamicSelectList && this.dynamicSelectList.length >= 1
      ? { ...this.dynamicSelectList[0] }
      : { id: "", name: "", description: "" };
  }

  set dynamicSelectListLocal(
    dynamicSelectListLocal: DynamicSelectData[] | DynamicSelectData
  ) {
    const dynamicSelectList = Array.isArray(dynamicSelectListLocal)
      ? [...dynamicSelectListLocal]
      : [{ ...dynamicSelectListLocal }];
    this.$emit(DYNAMIC_SELECT_EVENTS.UPDATE_DYNAMIC, dynamicSelectList);
    this.$emit(DYNAMIC_SELECT_EVENTS.CHANGE);
  }

  clickOutsideInclude() {
    const menu = document.querySelector(`.${this.contentClass}`);
    return menu ? [menu] : [];
  }

  emitBlur() {
    if (!this.outsideEnabled) return;
    this.$emit("blur");
  }
  onMenuUpdate(isOpen: boolean) {
    this.menuOpen = isOpen;
    if (isOpen) {
      this.$emit("focus");
    }
  }

  get clickOutsideConfig() {
    return { handler: this.emitBlur, include: this.clickOutsideInclude };
  }

  deleteElement(index: number) {
    if (
      this.dynamicSelectConfig.default.findIndex(
        element => element.id == this.dynamicSelectList[index].id
      ) >= 0
    ) {
      return;
    }
    if (
      this.dynamicSelectConfig.multiple &&
      Array.isArray(this.dynamicSelectListLocal)
    ) {
      if (
        this.dynamicSelectConfig.preventDeleteTheFirstElement &&
        this.dynamicSelectListLocal.length === 1
      ) {
        return;
      }
      this.dynamicSelectListLocal = [...this.dynamicSelectListLocal].filter(
        item =>
          item.id !==
          (this.dynamicSelectListLocal as DynamicSelectData[])[index].id
      );
    } else {
      this.dynamicSelectListLocal = { id: "", name: "" };
    }
  }

  //TODO: revisar porque no se usa
  createElement() {
    this.$emit(DYNAMIC_SELECT_EVENTS.CREATE);
  }

  loadElements() {
    this.$emit(DYNAMIC_SELECT_EVENTS.LOAD);
  }

  addElement(modal: string | undefined) {
    Utils.changeStateList(this, DYNAMIC_SELECT_REF, false);
    this.$emit(DYNAMIC_SELECT_EVENTS.ADD_ELEMENT, modal);
  }

  isSelected(item: any) {
    return this.dynamicSelectList.some(element => element.id == item.id);
  }

  toggleSelection(item: any) {
    //this.keyWord = "";
    const index = this.dynamicSelectList.findIndex(
      element => element.id == item.id
    );
    if (index === -1) {
      if (
        this.dynamicSelectConfig.limit &&
        this.dynamicSelectList.length == this.dynamicSelectConfig.limit
      ) {
        return;
      }
      this.dynamicSelectList.push(item);
    } else {
      this.dynamicSelectList.splice(index, 1);
    }
  }

  @Watch("keyWord")
  searchItem() {
    this.handleTextNotFound();
    Utils.searchItem(
      this.dynamicSelectConfig.listAll,
      this.keyWord,
      NAME_FIELD,
      this.setNotFoundData
    );
  }

  setNotFoundData(state: boolean) {
    this.noData = state;
  }

  disableBasicInfoGroup(item: DynamicSelectData) {
    return (
      this.dynamicSelectConfig.default.findIndex(
        element => element.id == item.id
      ) != -1
    );
  }

  onIntersect(options: IntersectionObserverEntry[]) {
    if (options[0].isIntersecting && !this.keyWord) {
      this.$emit(SELECT_EVENTS.EMITTERS.FETCH_DATA);
    }
  }

  searchData() {
    if (
      (!this.keyWord &&
        Boolean(this.dynamicSelectConfig.forceSearch) &&
        this.keyWord != null) ||
      (this.keyWord && this.keyWord.length >= 3)
    ) {
      if (!this.dynamicSelectConfig.forceSearch) {
        const result = this.dynamicSelectConfig?.listAll.filter(item =>
          item.name.toLowerCase().startsWith(this.keyWord.toLowerCase())
        );
        if (result.length > 0) return;
      }
      this.loading = true;
      this.$emit(SELECT_EVENTS.EMITTERS.FETCH_DATA, this.keyWord);
    }
  }

  @Watch("dynamicSelectConfig.notFound")
  setLoading() {
    if (this.dynamicSelectConfig.notFound) this.loading = false;
    this.handleTextNotFound();
  }

  @Watch("dynamicSelectConfig.listAll")
  deleteDuplicatedElements() {
    const result: DynamicSelectData[] = [];
    for (const item of this.dynamicSelectConfig.listAll) {
      const element = item;
      if (!result.find(e => e.id == element.id)) {
        result.push(element);
      }
    }

    if (this.dynamicSelectConfig.listAll.length != result.length)
      this.dynamicSelectConfig.listAll = result;

    this.loading = false;
  }

  handleTextNotFound() {
    if (this.keyWord && this.keyWord.length < 3) {
      this.textNotFound = DYNAMIC_SELECT_TEXT.MIN_CHARACTERS;
    } else if (this.dynamicSelectConfig.notFound) {
      this.textNotFound = DYNAMIC_SELECT_TEXT.NOT_FOUND;
    } else {
      this.textNotFound = DYNAMIC_SELECT_TEXT.NOT_FOUND;
    }
  }
}
